import React from "react";
import { getBreadCrumbs } from "@/lib/get-breadcrumbs";
import { StructuredDataBreadcrumb } from "@/components/structured-data/structured-data-breadcrumb";
import { Link } from "@/atoms";
import { DrupalNode } from "next-drupal";

export const BreadCrumbs = ({ content }: { content: DrupalNode }) => {
    const breadCrumbs = getBreadCrumbs(content);
    return (
        <>
            <nav className="divider" aria-label="Breadcrumb">
                <ul className="flex gap-4 items-center pr-4 text-body-md w-full flex-row overflow-x-auto overflow-y-hidden sm:overflow-x-hidden" >
                    {breadCrumbs.map((item, index) => (
                        <React.Fragment key={index} >
                            {item.link ?
                                <li className="min-w-fit w-auto gap-4 items-center inline-flex text-caption text-caption--m">
                                    <Link href={item.link} className="!text-text-primary hover:!text-text-secondary">{item.title}</Link>
                                    {'>'}
                                </li>
                                :
                                <React.Fragment>
                                    <li className="min-w-fit inline-flex gap-x-2 items-center text-caption text-caption--m line-clamp-1 w-auto text-text-secondary">
                                        <div aria-current="page">{item.title}</div>
                                    </li>
                                </React.Fragment>
                            }
                        </React.Fragment>
                    ))}
                </ul>
            </nav >
            <StructuredDataBreadcrumb path={content.path.alias} breadcrumbs={breadCrumbs} />
        </>
    );
};
